/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
import React from 'react'

import { EuiFlexGroup, EuiFlexItem } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'
import ExtendTrialButton from '@modules/trial-components/ExtendTrialButton'

import CreditCardModalButton from '@/components/Billing/CreditCard/CreditCardModalButton'

import SubscriptionOverviewPanel from '../components/SubscriptionOverviewPanel'

const ExpiredTrial = () => (
  <SubscriptionOverviewPanel
    title={
      <FormattedMessage id='trial-overview.expired.title' defaultMessage='Your trial has ended' />
    }
    content={
      <FormattedMessage
        id='trial-overview.expired.description'
        defaultMessage='Thank you for trying Elastic Cloud. Subscribe now to continue using our services and retrieve access to your cloud resources.'
      />
    }
    footer={
      <EuiFlexGroup>
        <EuiFlexItem grow={false}>
          <CreditCardModalButton type='full'>
            <FormattedMessage id='trial-overview.subscribe-button' defaultMessage='Subscribe' />
          </CreditCardModalButton>
        </EuiFlexItem>
        <ExtendTrialButton
          type='link'
          source_component_id='expired_billing_panel'
          buttonProps={{ style: { fontWeight: 'bold' } }}
        >
          <FormattedMessage
            id='trial-overview.trial-expiring-extend'
            defaultMessage='Extend your trial'
          />
        </ExtendTrialButton>
      </EuiFlexGroup>
    }
  />
)

export default ExpiredTrial
